function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Q9BG"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "st1 Q9BGn4",
  x1: 163.7,
  y1: 171,
  x2: 586.2,
  y2: 171
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "st1 Q9BGn3",
  x1: 163.7,
  y1: 134.3,
  x2: 586.2,
  y2: 134.3
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "st1 Q9BGn2",
  x1: 163.7,
  y1: 99.7,
  x2: 586.2,
  y2: 99.7
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "st1 Q9BGn1",
  x1: 163.7,
  y1: 52.7,
  x2: 586.2,
  y2: 52.7
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Q9bullet"
}, /*#__PURE__*/React.createElement("line", {
  className: "st3",
  x1: 228.9,
  y1: 143.6,
  x2: 0.4,
  y2: 143.6
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Q9footDaily"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  id: "Q9foot1",
  points: "363.3,189.5 363.3,183.5 363.3,176.9  "
}, /*#__PURE__*/React.createElement("animate", {
  className: "Q9foot1-back",
  attributeName: "points",
  attributeType: "XML",
  dur: "0.35s",
  begin: "none",
  fill: "freeze",
  to: "342,189.8 339.7,182.2 348.9,179",
  from: "363.3,189.5 363.3,183.5 363.3,176.9"
}), /*#__PURE__*/React.createElement("animate", {
  className: "Q9foot1-go",
  attributeName: "points",
  attributeType: "XML",
  dur: "0.35s",
  begin: "none",
  fill: "freeze",
  from: "342,189.8 339.7,182.2 348.9,179",
  to: "363.3,189.5 363.3,183.5 363.3,176.9"
})), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  id: "Q9shoesLeft",
  d: "M370,197.3l-22.9,0c0,0,9.5-9,18-7.7S370,197.3,370,197.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  id: "Q9shoesRight",
  d: "M406.6,196.7l-22.9,0c0,0,9.5-9,18-7.7S406.6,196.7,406.6,196.7z"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  id: "Q9foot2",
  points: "392.7,172.6 395.5,181.9 399.3,188.9  "
}, /*#__PURE__*/React.createElement("animate", {
  className: "Q9foot2-go",
  attributeName: "points",
  attributeType: "XML",
  dur: "0.35s",
  begin: "none",
  fill: "freeze",
  to: "392.7,172.6 395.5,181.9 399.3,188.9",
  from: "392.7,172.6 403.9,183 417.3,189.3"
}), /*#__PURE__*/React.createElement("animate", {
  className: "Q9foot2-back",
  attributeName: "points",
  attributeType: "XML",
  dur: "0.35s",
  begin: "none",
  fill: "freeze",
  from: "392.7,172.6 395.5,181.9 399.3,188.9",
  to: "392.7,172.6 403.9,183 417.3,189.3"
}))));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Q9footULT"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "342,189.8 339.7,182.2 348.9,179  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M351.4,197.3l-22.9,0c0,0,9.5-9,18-7.7S351.4,197.3,351.4,197.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M427.5,196.7l-22.9,0c0,0,9.5-9,18-7.7S427.5,196.7,427.5,196.7z"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "392.7,172.6 403.9,183 417.3,189.3  "
})));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Q9man"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "Q9underHandS",
  className: "st6",
  d: "M333.8,109.1l12.8-8c0.9-0.5,1.9-0.7,2.8-0.5c1.1,0.2,2.1,0.8,2.7,1.8 c1.2,1.9,0.6,4.3-1.3,5.5l-12.9,8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Q9underHandG",
  className: "st6",
  d: "M353.8,128.2l-15.1,0.1c-1,0-2-0.4-2.7-1c-0.8-0.7-1.3-1.8-1.3-3c0-2.2,1.8-4,4-4l15.1-0.1 "
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M351.1,164.8c0,0,2.5,10.8,11.5,11.8c15,1.6,17-4.7,17-4.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M369.3,173.7c0,0,15.7,8,25.5,4.1c14.1-5.5,12.5-12.4,12.5-12.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M411.6,156.9c0.1-16.7-3.3-61.7-5.2-82.2c-2-21.9-3.9-46.6-26.9-46.7c-23-0.2-25.7,25.5-27.8,47.7 c-1.9,20.2-5.9,66.6-6,80.8C345.5,176.5,411.5,177,411.6,156.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M350.3,92.5c-0.7,0.2-1.1-0.6-0.6-1.1c4.3-3.1,12.8-8.2,26.9-12.7c19.4-6.2,35.7-7.3,39.8-7.5 c0.5,0,0.8,0.4,0.6,0.9l-8.3,17.6c-0.1,0.2-0.3,0.4-0.6,0.3C403.9,89.6,367.1,86.6,350.3,92.5z"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(6.838950e-03 -1 1 6.838950e-03 267.955 485.4178)",
  className: "st9",
  cx: 378.4,
  cy: 107.8,
  rx: 15.3,
  ry: 12.3
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M350.1,92.6c-1.5,17.6-3.4,40-4.1,54.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M356.9,91c-1.5,17.6-2.9,34.3-3.7,48.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M362.6,91c-1.5,17.6-2.9,34.3-3.7,48.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M346.2,146.5l-6.3,18.9c0,0,28.6,14.3,56.7,6.4c15.9-4.5,23.1-9.1,23.1-9.1l-8.5-15.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M367.6,148.3c0,0-4.6,6.1-25.7,11"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M363.3,148.2c-3.8,2.1-10.2,4.7-20.2,7.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M411.4,147c-0.6-15.5-2.2-39-3.7-57"
}), /*#__PURE__*/React.createElement("line", {
  className: "st12",
  x1: 358.4,
  y1: 155.9,
  x2: 357.5,
  y2: 160.2
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M341.9,161.6c7,3,31,12.2,54.7,5.5c10.1-2.8,16.6-5.7,20.1-7.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M355.5,169.9L355.5,169.9c-2-0.4-3.2-2.4-2.8-4.4l0.7-2.9c0.4-2,2.4-3.2,4.4-2.8l0,0c2,0.4,3.2,2.4,2.8,4.4 l-0.7,2.9C359.4,169.1,357.4,170.3,355.5,169.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M353.5,162.2c0,0,1.9,1.6,3.1,1.9s3.9,0.1,3.9,0.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M352.7,165.5c0,0,1.9,1.6,3.1,1.9s3.9,0.1,3.9,0.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M404.4,146.2c0,0,2,5.1-11.7,9.1c-2.1,0.6-4.5,1.2-7.4,1.7c-21.8,4-34.5-11.5-34.5-11.5l-2.9,1.9 c0,0,14.1,18.1,38.2,13.4c3.2-0.6,5.9-1.3,8.2-2c15.2-4.6,13-10.6,13-10.6L404.4,146.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M412.8,145.5c-1.3,2.4-11.9,2.4-23.5,2.9c-11.6,0.5-47.9-1.1-47.9-1.1l2-8.8c0,0,34.1,1.4,45.4,0.3 c6-0.6,24.1-2.2,24.1-2.2L412.8,145.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M412.8,141.3c-25.7,5.5-64.9,1.8-64.9,1.8l1-4.4"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(6.838950e-03 -1 1 6.838950e-03 267.955 485.4178)",
  className: "st10",
  cx: 378.4,
  cy: 107.8,
  rx: 19.5,
  ry: 15.6
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M402.6,89c0.1,17.7,2,34.2,2.5,48.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M396.8,89c0.1,17.7,2,34.2,2.5,48.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M390.7,119.9c0.5,6.4,0.9,12.6,1.1,18.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M384.5,125.7c0.3,4.3,0.6,8.5,0.7,12.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M377.9,127.6c0,4.4-0.1,8.5-0.2,12.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M372.4,126.4c0,4.4-0.1,8.5-0.2,12.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M367.1,121.6c-0.5,4-0.7,11.5-0.1,16.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M409.4,72.6c0,0-6.7,6.5-6.8,17.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M399.4,73.2c0,0-4.2,8-3.4,15.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M388.7,75.4c0,0-3.1,11-1.1,13.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M376.7,78.7c0,0-3.2,6.7-0.7,9.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M365.9,82.7c0,0-2.1,4.8,0.3,6.8"
}), /*#__PURE__*/React.createElement("g", {
  id: "Q9sward"
}, /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M300.7,142l0.3,2.5c0.2,1.3,1.4,2.3,2.7,2.1l48.3-5.7c0.3,0,0.6-0.3,0.5-0.7l-0.7-6.1 c0-0.3-0.3-0.6-0.7-0.5l-48.3,5.7C301.5,139.5,300.5,140.7,300.7,142z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 335.8,
  y: 134.9,
  transform: "matrix(-0.1175 -0.9931 0.9931 -0.1175 259.5332 504.1885)",
  className: "st15",
  width: 36,
  height: 3.7
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M525.3,114.8l0.4,3.7c0.2,2-1.2,3.8-3.2,4.1l-161.8,19c-2,0.2-3.8-1.2-4.1-3.2l-0.4-3.7 c-0.2-2,1.2-3.8,3.2-4.1l161.8-19C523.2,111.4,525,112.8,525.3,114.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M514,124.1l-0.2-2.5c0-0.4,0.3-0.8,0.8-0.9l1.1-0.2c0.5-0.1,0.8-0.5,0.8-0.9l-0.4-3.7 c0-0.4-1-0.8-1.5-0.8l-0.9,0.1c-0.5,0-0.9-0.2-1-0.6l-0.2-1.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M370.6,130.1l3.1,3.6c0.5,0.6,0.6,1.4,0.2,2l-2.2,4.2c-0.3,0.6-1,1.1-1.8,1.2l-11.3,1.3 c-1.2,0.1-2.3-0.6-2.4-1.7l-0.9-7.7c-0.1-1.1,0.8-2.1,2-2.2l11.3-1.3C369.4,129.3,370.2,129.5,370.6,130.1z"
})), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 373.4,
  y1: 128.8,
  x2: 381.6,
  y2: 139
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 376.7,
  y1: 128.4,
  x2: 384.8,
  y2: 138.7
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 379.9,
  y1: 128.1,
  x2: 388,
  y2: 138.3
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 383.1,
  y1: 127.7,
  x2: 391.2,
  y2: 137.9
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 386.3,
  y1: 127.3,
  x2: 394.4,
  y2: 137.6
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 389.5,
  y1: 127,
  x2: 397.6,
  y2: 137.2
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 377.7,
  y1: 133.9,
  x2: 374.4,
  y2: 139.9
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 383.7,
  y1: 133.2,
  x2: 382.3,
  y2: 135.7
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 380.5,
  y1: 133.6,
  x2: 379.1,
  y2: 136.1
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 386.9,
  y1: 132.8,
  x2: 385.5,
  y2: 135.3
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 390.1,
  y1: 132.5,
  x2: 388.7,
  y2: 135
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 393.3,
  y1: 132.1,
  x2: 391.9,
  y2: 134.6
}))), /*#__PURE__*/React.createElement("g", {
  id: "Q9gun"
}, /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M260.4,147.3h-31.8c-1.8,0-3.3-1.5-3.3-3.3v0c0-1.8,1.5-3.3,3.3-3.3h31.8c1.8,0,3.3,1.5,3.3,3.3v0 C263.7,145.8,262.2,147.3,260.4,147.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M269.2,150.9h-1.1c-3.8,0-6.9-3.1-6.9-6.9v0c0-3.8,3.1-6.9,6.9-6.9h1.1c1.3,0,2.4,1.1,2.4,2.4v8.9 C271.6,149.8,270.5,150.9,269.2,150.9z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st18",
  points: "329.6,156.7 270.6,156.7 270.6,135.4 280.6,132.5 329.6,132.5  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st18",
  points: "327.9,132.5 322.5,127.9 305.3,132.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M279.9,148.4h24c0.8,0,1.5-0.7,1.5-1.5v-0.8c0-0.8-0.7-1.5-1.5-1.5h-24c-0.8,0-1.5,0.7-1.5,1.5v0.8 C278.5,147.7,279.1,148.4,279.9,148.4z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st20",
  cx: 324.1,
  cy: 138.4,
  r: 1.7
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st18",
  points: "343.8,158.4 329.6,163.8 329.6,132.5 381.4,132.5 381.4,145.4 363.8,145.8 358,158.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st18",
  points: "432.5,163.9 381.4,145.8 381.4,132.5 432.5,132.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st18",
  points: "389.4,148.7 381.4,145.8 381.4,132.5 389.4,132.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M348.4,166.8h5.4c2.3,0,4.2-1.9,4.2-4.2V158c0-2.3-1.9-4.2-4.2-4.2h-5.4c-2.3,0-4.2,1.9-4.2,4.2v4.6 C344.2,164.9,346.1,166.8,348.4,166.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M321,119.5h5.4c2,0,3.6-1.6,3.6-3.6v0c0-2-1.6-3.6-3.6-3.6H321c-2,0-3.6,1.6-3.6,3.6v0 C317.4,117.9,319,119.5,321,119.5z"
}), /*#__PURE__*/React.createElement("line", {
  className: "st18",
  x1: 329.6,
  y1: 163.8,
  x2: 307.4,
  y2: 156.7
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st20",
  points: "341.9,132.5 341.7,123.7 331.2,123.7 327.5,119.5 322.5,119.5 327.9,126.6 337.5,126.6  337.6,132.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M307.4,121.2h8.8c2.3,0,4.2-1.9,4.2-4.2v-2.1c0-2.3-1.9-4.2-4.2-4.2h-8.8c-2.3,0-4.2,1.9-4.2,4.2v2.1 C303.2,119.3,305.1,121.2,307.4,121.2z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M316.6,42.9c-0.5-7.2,24.2-20.6,55.6-22.7s57.7,7.7,58.2,14.9c0.5,7.2-24.6,14.8-56,17 S317.1,50.1,316.6,42.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M401.3,22c-5.2,2.1-16.1,4.1-28.7,4.9c-12.5,0.9-23.4,0.4-29-0.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M415.7,25.2c-8.9,3.3-24.7,6.2-42.7,7.4c-18.1,1.2-34.1,0.5-43.4-1.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M426.8,29.8c-11.7,5.4-31.1,9.6-53.2,11.1c-22.2,1.5-42-0.1-54.3-3.8"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "320.1,37.1 326.7,49.5 337.9,40.6 347.7,52.4 360.9,41.8 373.6,51.6 384.9,39.9 396.4,49.5  400.5,37.5 420.4,43.4 417.3,33.4 429.6,35.1  "
})), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  id: "Q9eye",
  d: "M358.2,68.6l0.3,0.6c0.1,0.3,0.5,0.4,0.7,0.2l4.1-2.3c0.3-0.1,0.4-0.5,0.2-0.7l-0.3-0.6 c-0.1-0.3-0.5-0.4-0.7-0.2l-4.1,2.3C358.2,68,358.1,68.3,358.2,68.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Q9upperHand",
  className: "st6",
  d: "M338,115.9l-11.5,7.1l6.4,19.2c0.7,2.1-0.4,4.4-2.5,5.1c-0.7,0.2-1.5,0.3-2.2,0.1 c-1.3-0.3-2.4-1.3-2.9-2.6l-7.4-22.2c-0.6-1.8,0.1-3.7,1.7-4.7l14.2-8.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Q9rotateHand",
  className: "st6",
  d: "M370,145.9c-0.6-0.1-1.2-0.4-1.7-0.8c-1.7-1.4-1.9-3.9-0.5-5.6l18.9-22.5l-8.6-7.9 c-1.6-1.5-1.7-4-0.2-5.7c1.5-1.6,4-1.7,5.7-0.2l11.4,10.4c1.6,1.4,1.7,3.9,0.4,5.5L374,144.6C373,145.8,371.5,146.2,370,145.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st23",
  d: "M352.4,75.9c8.4,0,13.9,5.7,15.8,1.4"
})));

var SvgQ9Svg = function SvgQ9Svg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Q9svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 714.5 202",
    style: {
      enableBackground: "new 0 0 714.5 202"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQ9Svg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Q9svg.3527e144.svg";
export { ForwardRef as ReactComponent };